// extracted by mini-css-extract-plugin
export var boldText = "_6s-4";
export var checkboxContainer = "_6s-6";
export var closeIcon = "_6s-i";
export var container = "_6s-0";
export var drawer = "_6s-8";
export var drawerContent = "_6s-9";
export var extraSmallText = "_6s-5";
export var fulfillmentGroupTable = "_6s-e";
export var largeText = "_6s-3";
export var loadingSpinnerContainer = "_6s-j";
export var mediumText = "_6s-2";
export var narrow = "_6s-f";
export var notificationLink = "_6s-l";
export var packageCheckIconContainer = "_6s-7";
export var slideoutHeaderActions = "_6s-g";
export var slideoutHeaderActionsShifted = "_6s-h";
export var slideoutHeaderContainer = "_6s-a";
export var slideoutModal = "_6s-c";
export var stickyHeaderWrapper = "_6s-b";
export var table = "_6s-k";
export var tableContainer = "_6s-d";
export var tertiaryText = "_6s-1";